import Dropdown from "app/components/Dropdown";
import { CheckIcon, Input, SearchIcon, UserIcon } from "app/components/Icons";
import MemberProfile from "app/components/MemberProfile";
import { members } from "app/containers/Features/containers/ProjectSettings/data";
import { IMember } from "app/containers/Features/containers/ProjectSettings/types";
import React, { useState } from "react";
import StatusSelectionButton from "./StatusSelectionButton";
import CommonAssigneeSelection from "app/containers/Features/components/CommonAssigneeSelection";
import { useSelector } from "react-redux";
import { selectTeamMembers } from "app/redux/selector";

interface AssigneeDropdownProps {
  value?: string;
  setValue?: (value: string) => void;
}

const AssigneeDropdown: React.FC<AssigneeDropdownProps> = ({
  setValue,
  value,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMember, setSelectedMember] = useState<IMember | null>(null);
  const selectTeamMember = useSelector(selectTeamMembers);
  const searchMembers = (members, keyword: string): IMember[] => {
    if (!keyword) return members;
    return members.filter(
      (member) =>
        member.name.toLowerCase().includes(keyword.toLowerCase()) ||
        member.role.toLowerCase().includes(keyword.toLowerCase())
    );
  };

  const filteredMembers = searchMembers(selectTeamMember, searchTerm);
  const handleSelect = (member: IMember) => {
    if (setValue) {
      setValue(member?._id);
    }
    setSelectedMember(member);
  };
  return (
    <>
      <CommonAssigneeSelection
        trigger={
          <button className="flex items-center justify-between w-full px-2 py-2 rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <StatusSelectionButton
              label="Assignee:"
              selectedLabel={selectedMember?.name ?? selectedMember?.name[0]}
              avatarColor={ selectedMember? selectedMember?.icon?.color:"" }
              icon={<UserIcon size={20} color="#79808A" />}
              className="text-[12px] leading-[18px] font-medium text-secondary mt-[2px]"
              showAvatar
            />
          </button>
        }
        align="end"
        searchKeyword={searchTerm}
        setSearchKeyword={(val) => {
          setSearchTerm(val);
        }}
        data={filteredMembers}
        selectedValue={value as string}
        updateValue={(member) => {
          handleSelect(member);
        }}
        isHeader="Assignees"
        searchPlaceholder="Search by assignee or role "
        dropdownContainerClassName="min-w-[270px]"
      />
    </>
  );
};

export default AssigneeDropdown;
